import Dictionary from "./container/Dictionary";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
function App() {
  return (
    <Dictionary />
  );
}

export default App;
